import { useEffect, useState } from "react";
import { API } from "./api";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import Dashboard from "./Dashboard";

export default function Clients() {
  const [apps, setApps] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null); // ✅ NEW
  const [selectedEnv, setSelectedEnv] = useState(null);

  useEffect(() => {
    API.get("/apps")
      .then((res) => {
        setApps(res.data.data || res.data || []);
      })
      .catch((err) => {
        console.error("API ERROR:", err);
      });
  }, []);

  // ✅ STEP 1 — CLIENT CARDS
  if (!selectedClient) {
    const clients = [...new Set(
      apps.map(a => (a.client || "").trim())
    )];

    return (
      <Grid container spacing={3}>
        {clients.map(client => (
          <Grid item xs={2} key={client}>
            <Card
              onClick={() => setSelectedClient(client)}
              style={{
                cursor: "pointer",
                background: `linear-gradient(135deg, #6366f1, #1e293b)`,
                color: "white",
                borderRadius: 12
              }}
            >
              <CardContent>
                <Typography>{client}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // ✅ STEP 2 — APPLICATION CARDS (NEW)
  if (selectedClient && !selectedApp) {
    const appsList = [...new Set(
      apps
        .filter(a =>
          (a.client || "").trim() === (selectedClient || "").trim()
        )
        .map(a => a.app_name)
    )];

    return (
      <Grid container spacing={3}>
        {appsList.map(app => (
          <Grid item xs={2} key={app}>
            <Card
              onClick={() => setSelectedApp(app)}
              style={{
                cursor: "pointer",
                background: `linear-gradient(135deg, #10b981, #1e293b)`,
                color: "white",
                borderRadius: 12
              }}
            >
              <CardContent>
                <Typography>{app}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // ✅ STEP 3 — ENV CARDS (UPDATED)
  if (selectedClient && selectedApp && !selectedEnv) {
    const envs = [...new Set(
      apps
        .filter(a =>
          (a.client || "").trim() === (selectedClient || "").trim() &&
          (a.app_name || "") === (selectedApp || "")
        )
        .map(a => a.environment)
    )];

    return (
      <Grid container spacing={3}>
        {envs.map(env => (
          <Grid item xs={2} key={env}>
            <Card
              onClick={() => setSelectedEnv(env)}
              style={{
                cursor: "pointer",
                background: `linear-gradient(135deg, #f59e0b, #1e293b)`,
                color: "white",
                borderRadius: 12
              }}
            >
              <CardContent>
                <Typography>{env}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  // ✅ STEP 4 — TABLE
  return (
    <Dashboard
      filterClient={selectedClient}
      filterApp={selectedApp}   // ✅ NEW
      filterEnv={selectedEnv}
      setSelectedClient={setSelectedClient}   // ✅ ADD
      setSelectedApp={setSelectedApp}         // ✅ ADD
      setSelectedEnv={setSelectedEnv}         // ✅ ADD
    />
  );
}

